'use client';

import { useRef } from 'react';

import dynamic from 'next/dynamic';

import ChevronLeft from '~/icons/chevron-left.svg';
import ChevronRight from '~/icons/chevron-right.svg';
import { IM20CategoriesModule } from '~/lib/data-contract';
import { CarouselArrows, CarouselButton } from '~/shared/components/Carousel/components';
import { Icon } from '~/shared/components/Icon/Icon';
import { ModuleContainer } from '~/templates/blocks/components/ModuleContainer/ModuleContainer';

import { CategoryCard } from './CategoryCard/CategoryCard';
import styles from './M20Categories.module.css';

const Carousel = dynamic(() => import('~/shared/components/Carousel/Carousel').then((mod) => mod.Carousel), {
	ssr: false,
	loading: () => <div className={styles.carouselPlaceholder} />,
});

export type M20CategoriesProps = IM20CategoriesModule;

export const M20Categories = ({ id, items, anchorId }: M20CategoriesProps) => {
	const prevRef = useRef<HTMLButtonElement>(null);
	const nextRef = useRef<HTMLButtonElement>(null);
	return (
		<ModuleContainer
			id={id}
			anchorId={anchorId?.toLowerCase()}
		>
			<div className={styles.root}>
				<CarouselArrows>
					<CarouselButton
						ref={prevRef}
						aria-label={'Show previous category item'}
					>
						<Icon
							size="2xl"
							aria-hidden
							children={<ChevronLeft />}
						/>
					</CarouselButton>
					<CarouselButton
						ref={nextRef}
						aria-label={'Show next category item'}
					>
						<Icon
							size="2xl"
							aria-hidden
							children={<ChevronRight />}
						/>
					</CarouselButton>
				</CarouselArrows>

				<Carousel
					enabledGradientContainer={true}
					nextRef={nextRef}
					prevRef={prevRef}
					items={items.map((item) => {
						const { link } = item;
						if (!link?.url) {
							return null;
						}
						return (
							<CategoryCard
								key={link?.id}
								link={link.url}
								name={link.text}
								selected={item.selected}
							/>
						);
					})}
				/>
			</div>
		</ModuleContainer>
	);
};
